// extracted by mini-css-extract-plugin
export default {"recos":"H5-z","productCardOverride":"I5-z","rowHasBadge":"J5-z"};